// extracted by mini-css-extract-plugin
module.exports = {"form":"ConfirmationDialog_form__3_3qE","inputFields":"ConfirmationDialog_inputFields__p9E-g"};